import React from "react";
import { IoCaretForwardOutline } from "react-icons/io5";

function PagesHero({ page }) {
  return (
    <div className="pages_hero">
      <div className="page_hero_container">
        <h2>{page}</h2>
        <div>
          <h4>Home</h4>
          <span>
            <IoCaretForwardOutline />
          </span>
          <p>{page}</p>
        </div>
      </div>
    </div>
  );
}

export default PagesHero;
